module.exports = __webpack_public_path__ + "img/friendly.b7f0532a.jpg";